import React from "react";
import PropTypes from "prop-types";

import * as types from "../../constants/ComponentConstants";
import RadioButtonGroup from "../common/RadioButtonGroup";
import TextAreaInput from "../common/TextAreaInput";

const RadioButtonText = (props) => {
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const optionList = props.items ? props.items : [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];
	const horizontal = !!props.horizontal;
	const tooltip = props.tooltip ? props.tooltip : "";
	const disabled = !!props.disabled;
	const locked = !!props.locked;
	const optional = !!props.optional;
	const labelJa = props.labelJa ? props.labelJa : "";
	const labelNee = props.labelNee ? props.labelNee : "";
	const titleJa = props.titleJa ? props.titleJa : "";
	const uClearOnNoTitle = titleJa == "" ? "u-clear" : "";
	const textJa = props.nameJa && (props.value === "true" || props.value == true) ?
		<div className={sizeClassName + uClearOnNoTitle}>
			<p>{titleJa}</p>
			<TextAreaInput
				name={props.nameJa}
				label={labelJa}
				value={props.valueJa}
				onChange={props.onChange}
				disabled={props.disabled}
				height={props.textAreaHeight}
				validationMessage={props.errorJa}
				validationMessageType={validationMessageType}
				maxLength={props.maxLengthJa}
			/> </div> : null;
	const textNee = props.nameNee && (props.value === "false" || props.value == false) ?
		<TextAreaInput
			name={props.nameNee}
			label={labelNee}
			value={props.valueNee}
			onChange={props.onChange}
			disabled={props.disabled}
			height={props.textAreaHeight}
			validationMessage={props.errorNee}
			validationMessageType={validationMessageType}
			maxLength={props.maxLengthNee}
		/> : null;

	return (
		<div className={"u-clear"}>
			<RadioButtonGroup
				labelInside={props.labelInside}
				name={props.name}
				label={props.label}
				onChange={props.onChange}
				items={optionList}
				value={props.value}
				horizontal={horizontal}
				tooltip={tooltip}
				tooltipType={tooltiptype}
				tooltipWindowWidth={props.tooltipWindowWidth}
				tooltipWindowAlignRight={props.tooltipWindowAlignRight}
				disabled={disabled}
				locked={locked}
				lockedText={props.lockedText}
				optional={optional}
				validationMessage={props.validationMessage}
				validationMessageType={validationMessageType}
			/>
			{textJa}
			{textNee}
		</div>
	);
};

RadioButtonText.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	onChange: PropTypes.func.isRequired,
	labelInside: PropTypes.bool,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	horizontal: PropTypes.bool,
	size: PropTypes.number,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	locked: PropTypes.bool,
	lockedText: PropTypes.string,
	optional: PropTypes.bool,
	valueJa: PropTypes.string,
	valueNee: PropTypes.string,
	nameJa: PropTypes.string,
	nameNee: PropTypes.string,
	labelJa: PropTypes.string,
	labelNee: PropTypes.string,
	errorJa: PropTypes.string,
	errorNee: PropTypes.string,
	textAreaHeight: PropTypes.number,
	titleJa: PropTypes.string,
	items: PropTypes.array.isRequired,
	maxLengthJa: PropTypes.number,
	maxLengthNee: PropTypes.number
};

export default RadioButtonText;
